import React from 'react';
import { FlyerCampaign } from '../../../../../models/interfaces/FlyerCampaign.interface';
import {
  CustomDataTableConfig,
  HeadCell,
} from '../../../../../commons/components/custom-data-table/custom-data-table-config.model';
import CustomDataTableComponent from '../../../../../commons/components/custom-data-table/custom-data-table.component';

interface FlyerCampaignTableComponentProps {
  flyerCampaigns: FlyerCampaign[];
  onSelect?: Function;
}

export default function FlyerCampaignTableComponent(props: FlyerCampaignTableComponentProps) {
  const headCells: HeadCell[] = [
    { id: 'id', field: 'id', label: 'ID' },
    { id: 'name', field: 'name', label: 'Campaign name' },
    { id: 'userEmail', field: 'userEmail', label: 'User Email' },
    { id: 'address', field: 'address', label: 'Address' },
    { id: 'radius', field: 'radius', label: 'Radius (km)' },
    { id: 'smsMessage', field: 'smsMessage', label: 'Message' },
    {
      id: 'numberToSend',
      label: 'target/total (available)',
      getFieldValueFunc: (flyerCampaign: FlyerCampaign) =>
        `${flyerCampaign.numberToSend}/${flyerCampaign.totalReceiver} (${flyerCampaign.availableReceiver})`,
    },
    { id: 'lastSent', field: 'lastSent', label: 'Last Sent' },
  ];

  const tableConfig: CustomDataTableConfig = {
    tableName: `Flyer campaigns`,
    rowsPerPage: 10,
    headCells,
  };

  return <CustomDataTableComponent tableConfig={tableConfig} data={props?.flyerCampaigns} onSelect={props?.onSelect} />;
}
